import { PointFeature } from 'supercluster';

type GroupedPointFeature<T> = PointFeature<{
  listings: Array<T>;
  // to check whether the object is cluster with type safety when using superclaster
  cluster: false;
}> & { id: string };

export function groupListingsByCoords<T>(
  listings: Array<PointFeature<T>>,
): Array<GroupedPointFeature<T>> {
  const groupedPins: { [key: string]: GroupedPointFeature<T> } = {};

  listings.forEach(listing => {
    const [lng, lat] = listing.geometry.coordinates;
    const id = `${lng}-${lat}`;

    if (!groupedPins[id]) {
      groupedPins[id] = {
        id,
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: listing.geometry.coordinates,
        },
        properties: {
          cluster: false,
          listings: [],
        },
      };
    }

    groupedPins[id]!.properties.listings.push({
      ...listing.properties,
    });
  });

  return Object.values(groupedPins);
}
